import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { useLocation } from "react-router-dom";
// import format from "date-fns/format";

// import DetailsPageFooter from "../../../common/details_footer/DetailsPageFooter";
// import dateFns from "date-fns";
// import { getCreatedBy, getUpdatedBy } from "../../../common/updateByInfo";
import { connect, useDispatch, useSelector } from "react-redux";
import { MuiTooltip, Notifier, ErrorNotifier } from "../../../components";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
// import { rowSelect } from "../../../../features/hcm/hr/emp_management/empManagementSlice";
import GridDataDetails from "../../../components/common/tab/GridDataDetails";

import UpdateChrUserDetails from "./UpdateChrUserDetails"
import { deleteAccountChr, getAccountChr, resetMessage, resetErrMessage } from "../../../features/auth/authChrSlice";
// import CommonErrorMessage from "../../../common/error-message/CommonErrorMessage";
// import CommonStatusPopUp from "../../../common/CommonStatusPopUp";
// import {
//   deleteApiProjectBacklog,
//   getAllApiProjectBacklog,
//   getApiProjectBacklog,
//   updateApiProjectBacklog,
//   rowSelectApiProjectBacklog,
//   getApiProjectBacklogDetails,
// } from "../../../../../api_calls/projectBacklog/apiCalls";
// import { timeoutCall } from "../../../common/timeoutCall/timeoutCall";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
// import {
//   deleteAssignedPeople,
//   getAssignedPeople,
// } from "../../../../../features/project/requirementsManagement/projectBacklog/assignedToPeopleSlice";
// import AddAssignToPeople from "./assign_to_people/AddAssignToPeople";
// import { getProjectUser } from "../../../../../features/project/projectInfo/projectUsersSlice";
import AddCircleIcon from "@mui/icons-material/AddCircle";
// import {
//   getBacklogStatusHistory,
//   getProjectBacklogDetailsForBacklog,
//   updateProjectBacklogPatch,
// } from "../../../../../features/project/requirementsManagement/projectBacklog/projectBacklogSlice";
// import UserDetails from "../../common/UserDetails";
// import { checkApiPermissionWithAuth } from "../../../../common/check-api-permission/checkApiPermission";
// import {
//   deleteBacklogMember,
//   getBacklogMember,
// } from "../../../../../features/project/requirementsManagement/projectBacklog/backlogMemberSlice";
// import AddBacklogMember from "./assign_to_people/AddBacklogMember";
// import CommonStatusHistory from "../../common/commonStatusHistory";
// -----------------------------------------------------------------------------------------------------------------
const ProjectBacklogDetailsView = ({ details, ...props }) => {
  const [viewMore, setViewMore] = useState(true);
  const [viewStatusChange, setViewStatusChange] = useState(false);
  const [showStatusHistory, setShowStatusHistory] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false)
  const [showBacklogMember, setShowBacklogMember] = useState(false);

  const { accountData, selectedData, message, errMessage } = useSelector((state) => ({ ...state.authChr }))

  const backlogStatus = useSelector((state) => state?.backlogStatus);

  const dispatch = useDispatch();
  const location = useLocation();
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [showUserData, setShowUserData] = useState([]);



  // const formatDateOrHyphen = (date) => {
  //   if (!date) {
  //     return "-";
  //   }
  //   return format(date, "DD-MM-YYYY"); 
  // };

  const [newdetails, setDetails] = useState([]);

  useEffect(() => {
    try {
      const filteredDetails = accountData?.filter(
        (item) =>
          item?.id === selectedData.id || props?.valueId //this is the existing data which is already displaying that data we will compare
      );

      console.log(filteredDetails)


      setDetails(filteredDetails);
      // props?.rowSelect(filteredDetails);


    } catch (err) {
      console.log(err);
    }
  }, [accountData]);

   

  // useEffect(() => {
  //   try {
  //     dispatch(
  //       getAssignedPeople({
  //         projBacklogId: props?.projectBacklog?.selectedData?.id,
  //       })
  //     );
  //     dispatch(
  //       getBacklogMember({
  //         projectBacklogId: props?.projectBacklog?.selectedData?.id,
  //       })
  //     );

  //     dispatch(getProjectUser());
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, []);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const handleUpdateFunction = useCallback(
    (status) => {
      // const res = await updateApiProjectBacklog(
      //   {
      //     id: details[0]?.id ?? null,
      //     productInfoId: details[0]?.productInfoId ?? null,
      //     moduleInfoId: details[0]?.moduleInfoId ?? null,
      //     type: details[0]?.type ?? "",
      //     name: details[0]?.name ?? "",
      //     description: details[0]?.description ?? "",
      //     priority: details[0]?.priority ?? "",
      //     severity: details[0]?.severity ?? "",
      //     status: status ?? "",
      //     acceptanceCriteria: details[0]?.acceptanceCriteria ?? "",
      //     defectType: details[0]?.defectType ?? "",
      //   },
      //   dispatch
      // );
      // dispatch(
      //   updateProjectBacklogPatch({
      //     id: details[0]?.id,
      //     status: status,
      //   })
      // ).then((res) => {
      //   if (res?.payload?.data?.ok) {
      //     dispatch(
      //       getProjectBacklogDetailsForBacklog({
      //         id: details[0]?.id,
      //       })
      //     );
      //     dispatch(
      //       getBacklogStatusHistory({
      //         projectBacklogId: props?.projectBacklog?.selectedData?.id,
      //       })
      //     );
      //     timeoutCall(() => setViewStatusChange(false));
      //   }
      // });
    },
    [details]
  );
  const handleCloseConfirmDialog = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  const handleClickDelete = useCallback(() => {
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDelete(),
    });

    const handleDelete = () => {
      let data = {
        id: selectedData?.assessmentUserChr?.id,
      };
      dispatch(deleteAccountChr(data)).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            });
            dispatch(getAccountChr(
            ));
            props?.setValue(location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? 2 : 1)
          }, 2000);
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
      });
    };
  }, [props?.myProject, details]);

  const deleteUser = useCallback((val) => {
    const handleDelete = (val) => {
      try {
        let data = {
          id: val?.id,
        };

        // dispatch(deleteAssignedPeople(data)).then((res) => {
        //   if (res?.payload?.data?.ok) {
        //     setTimeout(() => {
        //       handleCloseConfirmDialog();
        //       dispatch(
        //         getAssignedPeople({
        //           projBacklogId: props?.projectBacklog?.selectedData?.id,
        //         })
        //       );
        //     }, 2000);
        //   }
        // });
      } catch (err) {
        console.log(err);
      }
    };
    handleDelete(val);
  }, []);

  const deleteUserBacklog = (val) => {
    try {
      let data = {
        id: val?.id,
      };

      // dispatch(deleteBacklogMember(data)).then((res) => {
      //   if (res?.payload?.data?.ok) {
      //     setTimeout(() => {
      //       handleCloseConfirmDialog();
      //       dispatch(
      //         getBacklogMember({
      //           projectBacklogId: props?.projectBacklog?.selectedData?.id,
      //         })
      //       );
      //     }, 2000);
      //   }
      // });
    } catch (err) {
      console.log(err);
    }
  };

  // const ownerDataDetails = () => {
  //   let items = [];
  //   if (props?.assignedToPeople?.assignedToPeopleData?.length > 0) {
  //     props?.assignedToPeople?.assignedToPeopleData?.map((item, i) => {
  //       items.push(
  //         <div
  //           key={item?.ownershipType}
  //           // style={{ height: ".5rem", marginTop: "-0.5rem" }}
  //           title={
  //             (item?.piedap_user?.email ?? "") + " - " + item?.ownershipType
  //           }
  //           style={{ fontSize: "14px" }}
  //           onClick={() => {
  //             setShowUserInfo(true);
  //             setShowUserData({
  //               id: item?.piedapUserId,
  //               email: item?.piedap_user?.email ?? "",
  //             });
  //           }}
  //         >
  //           {(item?.piedap_user?.email ?? "") + " - " + item?.ownershipType}
  //           {props?.assignedToPeople?.assignedToPeopleData?.length - 1 === i
  //             ? ""
  //             : "\n"}
  //           {/* {checkApiPermissionWithAuth(
  //             props?.auth,
  //             "Project360.Backlog.deleteBacklogOwner"
  //           ) && ( */}
  //             <MuiTooltip title="Delete" placement="bottom">
  //               <IconButton
  //                 onClick={(e) => {
  //                   e.stopPropagation();
  //                   setConfirmDialog({
  //                     isOpen: true,
  //                     title: "Are you sure to delete this record?",
  //                     subTitle: "You can't undo this operation",
  //                     onConfirm: () => deleteUser(item),
  //                   });
  //                 }}
  //                 size="small"
  //               >
  //                 <DeleteIcon
  //                   sx={{ color: "red !important", fontSize: "large" }}
  //                 />
  //               </IconButton>
  //             </MuiTooltip>
  //           {/* )} */}
  //         </div>
  //       );
  //     });
  //   }
  //   return items;
  // };
  // const memberDataDetails = () => {
  //   let items = [];
  //   if (props?.backlogMember?.data?.length > 0) {
  //     props?.backlogMember?.data?.map((item, i) => {
  //       items.push(
  //         <div
  //           key={item?.ownershipType}
  //           // style={{ height: ".5rem", marginTop: "-0.5rem" }}
  //           title={
  //             (item?.piedap_user?.email ?? "") + " - " + item?.ownershipType
  //           }
  //           style={{ fontSize: "14px", }}
  //           onClick={() => {
  //             setShowUserInfo(true);
  //             setShowUserData({
  //               id: item?.piedapUserId,
  //               email: item?.piedap_user?.email ?? "",
  //             });
  //           }}
  //         >
  //           {item?.piedap_user?.email ?? ""}
  //           {props?.backlogMember?.data?.length - 1 === i ? "" : "\n"}

  //           {props?.permissions?.permissionsData?.piedap?.customerUser?.projectBacklog?.assignedTo?.delete &&
  //             <MuiTooltip title="Delete" placement="bottom">
  //             <IconButton
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 setConfirmDialog({
  //                   isOpen: true,
  //                   title: "Are you sure to delete this record?",
  //                   subTitle: "You can't undo this operation",
  //                   onConfirm: () => deleteUserBacklog(item),
  //                 });
  //               }}
  //               size="small"
  //             >
  //               <DeleteIcon
  //                 sx={{ color: "red !important", fontSize: "large" }}
  //               />
  //             </IconButton>
  //           </MuiTooltip>}
  //         </div>
  //       );
  //     });
  //   }
  //   return items;
  // };

  // let defectTypeData = "";
  // if (details.length > 0 && details[0].type) {
  //   const type = details[0].type.toLowerCase();
  //   defectTypeData =
  //     type === "defect"
  //       ? `${details[0].type} ${details[0].defectType ? "-" : ""}   ${
  //           details[0].defectType || ""
  //         }`
  //       : details[0].type
  //       ? details[0].type
  //       : "";
  // }

  // try {
  // console.log("NEWPROPS",props?.empManagement?.empManagementData)
  // console.log("Selected data",props?.empManagement?.selectedData)
  return (
    <Card
      sx={{
        boxShadow: "0 4px 8px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19)",
        paddingTop: "0px!important",
        paddingLeft: "0px!important",
        paddingRight: "0px!important",
        borderRadius: ".25rem",
        height: "100%",
      }}
    >
      <CardContent
        sx={{
          height: "100%",
          padding: "0rem!important",
          paddingBottom: "0rem!important",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Grid
            container
            className="center bold pt-2 radius-p3
        background-color tabs-header-font-style tabs-border"
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "0px !important",
            }}
          >
            <Grid item xs={props?.forViewDetails ? 8.5 : 9.5} display="flex">
              <IconButton onClick={() => setViewMore(prev => !prev)}>
                <MuiTooltip title={viewMore ? "View Less" : "View More"}>
                  {viewMore ? (
                    <KeyboardArrowUpIcon className="tabs-icon-color" />
                  ) : (
                    <KeyboardArrowDownIcon className="tabs-icon-color" />
                  )}
                </MuiTooltip>
              </IconButton>

              {/* Center this div */}
              <div style={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                Details of {`${newdetails[0]?.firstName || ""} ${newdetails[0]?.lastName || ""}`}
              </div>
            </Grid>

            <Grid
              item
              xs={1}
              sm={1}
              md={0.5}
              lg={0.5}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-0.3rem",
              }}
            >

              <MuiTooltip title="Update">
                <IconButton
                  onClick={() => setShowEdit(true)}>
                  <EditIcon className="tabs-icon-color" />
                </IconButton>
              </MuiTooltip>

            </Grid>
            <Grid
              item
              xs={1}
              sm={1}
              md={0.5}
              lg={0.5}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-0.3rem",
              }}
            >

              <MuiTooltip title="Delete" placement="bottom">
                <IconButton onClick={() => handleClickDelete()}>

                  <DeleteIcon sx={{ color: "red !important" }} />
                </IconButton>
              </MuiTooltip>

            </Grid>

            <Grid
              item
              xs={1}
              md={1}
              lg={1}
              xl={1}
              sm={1}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              
                // marginTop: "-0.3rem",
              }}
            >
              <Button
                color="error"
                variant="outlined"
                onClick={()=>{
                  console.log("clicked ",props?.val)
                  props?.setValue(location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? 2 : 1)
                
                }}
              >
                Close
              </Button>
            </Grid>

          </Grid>
        </Box>



        {viewMore && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                maxHeight: "30vh",
                marginBottom: "0.5rem",
                padding: "0.5rem",
              }}
            >
              <Grid container>

                <Grid item xs={12} md={6} lg={6} sm={12} xl={6}>
                  <GridDataDetails
                    title="Customer Name"
                    data={
                      newdetails?.length > 0
                        ? newdetails[0]?.assessmentUserChr?.assessmentCustomer?.customerName
                        : ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  <GridDataDetails
                    title="User Name"
                    data={
                      newdetails?.length > 0
                        ? `${newdetails[0].firstName || ""} ${newdetails[0].lastName || ""}`
                        : ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  <GridDataDetails
                    title="User Group"
                    data={
                      newdetails?.length > 0
                        ? [...new Map(newdetails[0]?.assessmentUserRoleChr?.map(item => [item.userRoleChr?.userGroupChr['id'], item.userRoleChr?.userGroupChr])).values()].map(item => `${item?.groupName} `)
                        : ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  <GridDataDetails
                    title="Primary Role"
                    data={newdetails[0]?.assessmentUserRoleChr.map(item => item.isPrimary && item?.userRoleChr?.roleName)}
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  <GridDataDetails
                    title="Secondary Role"
                    data={
                      newdetails[0]?.assessmentUserRoleChr.map(item => !item.isPrimary && `${item?.userRoleChr?.roleName}, `) || ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />
                  <GridDataDetails
                    title="Email"
                    data={
                      newdetails?.length > 0
                        ? newdetails[0]?.assessmentUserChr?.email
                        : ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  {/* <GridDataDetails
                    title="Employment Geo"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.geoName : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  />
                  <GridDataDetails
                    title="Employment Country"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.countryName : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  /> */}
                </Grid>

                <Grid item xs={12} md={6} lg={6} sm={12} xl={6}>
                  <GridDataDetails
                    title="Geography"
                    data={
                      newdetails?.length > 0
                        ? newdetails[0]?.geoName
                        : ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />
                  <GridDataDetails
                    title="Country"
                    data={newdetails[0]?.country}
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />
                  <GridDataDetails
                    title="Contact No."
                    data={
                      `${newdetails[0]?.dialingCode}-${newdetails[0]?.contactNumber}`
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  {/* <GridDataDetails
                    title="Employment State"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.state : ""}
                      mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  <GridDataDetails
                    title="Work Location"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.locationName : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  />
                  <GridDataDetails
                    title="Position"
                    data={newdetails?.length > 0 ? newdetails[0]?.pieUserEmployee?.empGrade?.empPosition?.positionName
                      : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  />
                  <GridDataDetails
                    title="Grade"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee?.empGrade
                      ?.grade : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  /> */}

                  <GridDataDetails
                    title="Comments"
                    data={
                      newdetails?.length > 0
                        ? newdetails[0]?.comments
                        : ""
                    }
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />

                  {/* <GridDataDetails
                    title="Organization Name"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee?.
                      department?.
                      businessUnit?.organization?.orgLegalEntityName
                      : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  />
                  <GridDataDetails
                    title="Business Unit"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.department?.
                      businessUnit?.busiUnitName

                      : ""}
                      mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />
                  <GridDataDetails
                    title="Department"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.department?.departmentName
                      : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  />
                  <GridDataDetails
                    title="Employee Type"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.empType?.
                      employeeTypeName
                      : ""}
                      mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />
                  <GridDataDetails
                    title="Organization Email Id"
                    data={newdetails?.length > 0 ? newdetails[0]?.email : ""}
                    mdt={3.8}
                    mdc={0.2}
                    mdd={8}
                  />
                  <GridDataDetails
                    title="Employee Status"
                    data={newdetails?.length > 0 ? newdetails[0]?.
                      pieUserEmployee
                      ?.empStatusReason?.
                      empStatus?.empStatus
                      : ""}
                      mdt={3.8}
                      mdc={0.2}
                      mdd={8}
                  /> */}
                </Grid>

                {/* <Grid item xs={12} md={12} lg={12} sm={12} xl={12}>
                    <GridDataDetails
                      title="Description"
                      data={details?.length > 0 ? details[0].description : ""}
                      mdt={1.5}
                      mdc={0.1}
                      mdd={10.4}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} sm={12} xl={12}>
                    <GridDataDetails
                      title="Acceptance Criteria"
                      data={
                        details?.length > 0 ? details[0].acceptanceCriteria : ""
                      }
                      mdt={1.5}
                      mdc={0.1}
                      mdd={10.4}
                    />
                  </Grid> */}
              </Grid>
            </div>

            <div style={{ overflow: "hidden" }}>
              <Divider />
              {/* <DetailsPageFooter
                createdBy={props?.empManagement?.selectedData.createdBy}
                createdOn={props?.empManagement?.selectedData.createdOn}
                updatedBy={props?.empManagement?.selectedData.updatedBy}
                updatedOn={props?.empManagement?.selectedData.updatedOn}
              /> */}
            </div>
          </div>
        )}


      </CardContent>

      {showEdit && <UpdateChrUserDetails selectedData={newdetails[0]} showEdit={showEdit} back={() => setShowEdit(false)} />}
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />

      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}

    </Card>
  );
  // }
  // catch (err) {
  //   console.log(err);
  //   return <CommonErrorMessage />;
  // }
};

const mapStateToProps = (state) => ({
  empManagement: state.empManagement,
  myProject: state.myProject,
  permissions: state.permissions,
  assignedToPeople: state.assignedToPeople,
  projectBacklog: state.projectBacklog,
  backlogMember: state.backlogMember,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(
  ProjectBacklogDetailsView
);
